import { SignalRProvider } from 'brokertslib/src/context/SignalRProvider'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SendCalculationModal, SendCalculationVehicleContextProvider } from '@/containers/SendCalculationModal'
import CarkulkaExtraOffersProvider from '@/context/CarkulkaExtraOffersProvider'
import CarkulkaOffersProvider from '@/context/CarkulkaOffersProvider'
import { SortBy } from '@/context/OffersProvider'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { OffersCar } from '../../../containers/offers/OffersCar'
import { StepsContent } from '../../../context/StepsContext'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

const baseUrl = import.meta.env.VITE_BASE_URL
const hubUrl = import.meta.env.VITE_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

export const Step3 = () => {
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParamsContext()

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 2) {
    navigate('/carkulka/wizard/too-far', { replace: true })
  }

  const [order, setOrder] = useState(1)
  const setOrderFunc = (order: SortBy) => {
    switch (order) {
      case SortBy.Insurer:
        setOrder(3)
        break

      case SortBy.VariantInsurer:
        setOrder(2)
        break

      case SortBy.VariantPrice:
        setOrder(5)
        break

      default:
        setOrder(1)
        break
    }
  }

  const isContract = !!insuranceParams?.generalParams.contractNumber

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) &&
          <StepsContent step={3}>
            <SignalRProvider url={url}>
              <Steps icon="car" />

              {paramsId && (
                <CarkulkaOffersProvider insuranceParamsId={paramsId} isContract={isContract}>
                  <CarkulkaExtraOffersProvider insuranceParamsId={paramsId} isContract={isContract}>
                    <SendCalculationVehicleContextProvider order={order}>

                      <SendCalculationModal />

                      <InsuranceInfo />

                      <OffersCar setOrderFunc={setOrderFunc} />
                      
                    </SendCalculationVehicleContextProvider>
                  </CarkulkaExtraOffersProvider>
                </CarkulkaOffersProvider>
              )}
            </SignalRProvider>
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
